<script>
  import Link from "$lib/components/Link.svelte";
  import { isExternalUrl } from "$lib/utilities/url-helpers";
  // eslint-disable-next-line  @ObamaFoundation/of-svelte/no-stores
  import { page } from "$app/stores";
  import ExternalLinkLabel from "$lib/components/ExternalLinkLabel.svelte";

  export let title;
  export let description = "";
  export let url = "";

  $: isExternal = isExternalUrl(url, $page.url?.origin);
</script>

<div class="flex flex-col gap-8 w-full lg:w-[801px] px-48 md:px-72 lg:px-0">
  <Link {url} class="!px-0">
    <div class="text-size-16 leading-normal">
      {#if isExternal}
        <ExternalLinkLabel text={title} iconClass="!inline mx-2 align-top" />
      {:else}
        {title}
      {/if}
    </div>
  </Link>

  <p class="font-normal line-clamp-3 md:line-clamp-10">{description}</p>
</div>
